"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointSelector = void 0;
var breakpointSelector = function (props, size) {
    return props.theme.variables.breakpoints[size];
};
exports.breakpointSelector = breakpointSelector;
var getBreakpoint = function (size) {
    return function (props) { return exports.breakpointSelector(props, size); };
};
exports.default = getBreakpoint;
//# sourceMappingURL=index.js.map